import React, { FC, ReactNode } from 'react';
import clsx, { ClassValue } from 'clsx';
import ReactSelect from 'react-select';
import { ISelectOptions } from 'utils/models';

interface ISelect {
  options: ISelectOptions[];
  value: any;
  onChange: (x: any) => void;
  label?: string;
  className?: ClassValue;
  placeholder?: string;
  icon?: ReactNode;
  round?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'r-2xl' | 'full';
  disabled?: boolean;
}

const customStyles = {
  option: (style: any, state: any) => {
    const customColors = {
      ...style,
      color: state.isFocused ? '#ffffff' : '#000000',
      backgroundColor: state.isFocused ? '#731300' : '#ffffff',
      ':active': {
        ...style[':active'],
        backgroundColor: '#731300'
      }
    };

    return customColors;
  }
};

const Select: FC<ISelect> = ({
  label,
  options,
  value,
  onChange,
  className,
  placeholder,
  icon,
  round = 'md',
  disabled = false
}) => {
  const optionValue = options.find((item: ISelectOptions) => item.value === value);

  return (
    <div className={clsx(className)}>
      <div className={clsx((icon || label) && 'mb-3', 'flex items-center gap-2')}>
        {icon && icon}
        {label && <label className="text-sm">{label}</label>}
      </div>
      <ReactSelect
        styles={{
          ...customStyles,
          menu: (provided) => ({ ...provided, zIndex: 99999 }),
          menuPortal: (provided) => ({ ...provided, zIndex: 99999, position: 'fixed' })
        }}
        options={options}
        onChange={(x) => onChange(x?.value)}
        value={optionValue}
        classNamePrefix="form-select"
        placeholder={placeholder}
        className={clsx('relative text-left form-select w-full', `round-${round}`)}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: '#dbeafe'
          }
        })}
        isDisabled={disabled}
        menuPlacement="auto"
        menuPortalTarget={document.getElementById('menu-portal')}
        menuShouldBlockScroll
      />
    </div>
  );
};

export default Select;
